import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'core-counter-widget',
  imports: [],
  templateUrl: './counter-widget.html',
  styleUrl: './counter-widget.scss',
  standalone: true,
  host: {
    style: 'border-radius: 0.75rem;width:100%;padding:1.5rem 1rem;gap:1rem;display:flex;flex-direction:column;justify-content:space-between;',
    class: 'bg-neutral-100'
  }
})
export class CounterWidget {

  @Input()
  type: string = '';
  @Input()
  title: string = '';
  @Input()
  subTitle: string = 'Actualmente tienes';
  @Input()
  description: string = '';
  @Input()
  value: number = 0;
  @Input()
  icon: string = '';
  @Input()
  hasProgress: boolean = false;
  @Input()
  progressLabel: string = '';
  @Input()
  target: number = 0;
  @Input()
  showAction: boolean = true;
  @Input()
  fraction: boolean = false;
  @Input()
  progressInset: boolean = false;
  @Input()
  highlight: boolean = false;
  @Output()
  onClicked = new EventEmitter();

  protected onClick() {
    this.onClicked.emit();
  }
}
